import createApiOptions from '../../utils/createApiOptions';
import callFetch from '../../access/callFetch';
import { BASE_INFORM_API_URL } from '../../services/constants';
var screen = 'arterms';
export var updateARTerms = function (_a) {
    var dataId = _a.dataId, properties = _a.properties;
    var options = createApiOptions({
        body: { dataId: dataId, properties: properties },
        method: 'post'
    });
    return callFetch("".concat(BASE_INFORM_API_URL, "/").concat(screen, "/update"), options);
};
export var deleteARTerms = function (_a) {
    var dataId = _a.dataId;
    var options = createApiOptions({
        body: { dataId: dataId },
        method: 'post'
    });
    return callFetch("".concat(BASE_INFORM_API_URL, "/").concat(screen, "/delete"), options);
};
export var createARTerms = function (_a) {
    var dataId = _a.dataId;
    var options = createApiOptions({
        body: { dataId: dataId },
        method: 'post'
    });
    return callFetch("".concat(BASE_INFORM_API_URL, "/").concat(screen, "/create"), options);
};
export var closeCustomerTerms = function () {
    var options = createApiOptions({
        body: {},
        method: 'post'
    });
    return callFetch("".concat(BASE_INFORM_API_URL, "/").concat(screen, "/close"), options);
};
